<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Place Order</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><b>Academic Year</b><v-icon class="pb-2 pl-1" color="error">*</v-icon></p>
            <v-autocomplete color="#0F2027" dense required v-model="ay" :items="ay_list" item-text="ay" item-value="id"
              outlined persistent-hint hint="Please Select Academic Year" />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Enter Student PRN</b><v-icon class="pb-2 pl-1" color="error">*</v-icon></p>
            <v-text-field outlined dense ref='focusMe' type="text" v-model="prn" @keydown="handleKeyDown"
              autofocus></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" md="2" align="center">
            <v-btn style="color:orange" class="mt-11" outlined dense rounded :disabled="!prn" :loading="loader"
              @click="fetchStudentData()">
              Fetch Details</v-btn>
          </v-col>

        </v-row>
      </v-card>
      <v-card class="box" v-if="learner_details != ''">
        <v-row justify="center" allign="center" dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col cols="12" sm="6" md="6">
            <v-row justify="center" dense>
              <v-col cols="12" sm="" md="6">
                <p><b>Standard : </b> {{ learner_details[0].standard }}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <p><b>Division : </b> {{ learner_details[0].division }}</p>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="6" md="6">
                <p><b>Roll No : </b> {{ learner_details[0].roll_no }}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <p><b>DOB : </b> {{ learner_details[0].dob }}</p>

              </v-col>
            </v-row>

            <v-row justify="center" dense>
              <v-col cols="12" sm="6" md="6">
                <p><b>Mother Name : </b> {{ learner_details[0].mother_name }}</p>

              </v-col>
              <v-col cols="12" sm="6" md="6">
                <p><b>Allergy : </b> {{ learner_details[0].allergy }}</p>
              </v-col>
            </v-row>


          </v-col>
          <v-col cols="12" sm="3" md="3">
            <center>
              <v-img width="150" :src="awspath + learner_details[0].photo_url" aspect-ratio="1" class="grey lighten-2"
                style="border: 1px solid black;"></v-img>
              <p><b>{{ learner_details[0].learner }}</b></p>
            </center>
          </v-col>
        </v-row>
        <v-data-table :headers=headers1 :items="installments" class="elevation-1 i-table mytable" dense
          hide-default-footer>
          <template v-slot:item.manu_taken="{ item }">
            <span><b>{{ item.manu_taken }}</b></span>
          </template>
        </v-data-table>
    
        <br><br>
        <v-row v-if="installments && installments.length && installments.some(inst => inst.fees_paid > 0)" justify="center" >
          <div class="mr-5"><b>Select Menu Type</b></div>

          <span v-for="(inst, i) in installments" :key="i" class="radio-group">
            <span v-for="(menu, j) in inst.canteen_menu_type_list" :key="j" class="radio-container">
              <input type="radio" class="radiospace" v-model="canteen_menutype" :value="{
                menuId: menu.id,
                instId: inst.installment_id
              }" />
              {{ menu.name }}
            </span>
          </span>
          <v-btn small style="color:orange" outlined dense rounded :disabled="!prn || !canteen_menutype" :loading="loader"
            @click="PlaceMealOrder()">
            Place Order
          </v-btn>
        </v-row>
        <br>
      </v-card>

      <v-card class="box" v-if="todays_order_list != ''">
        <v-data-table :headers="headers" :items="todays_order_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Today's Orders</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    search: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    prn: "",
    learner_details: [],
    show_stud_data: false,
    headers1: [
      { text: 'Menu Taken', value: 'manu_taken' },
      { text: 'Total Fees', value: 'total_fees' },
      { text: 'Total Paid', value: 'fees_paid' },
      { text: 'Fees Paid Date', value: 'paid_date' }
    ],
    headers: [
      { text: "SR No", value: "count" },
      { text: "Date", value: "date" },
      { text: "PRN", value: "prn" },
      { text: "Student", value: "learner" },
      { text: "Menu Taken", value: "canteenmenutype" },
      { text: "Standard", value: "standard" },
      { text: "Division", value: "division" },
      { text: "Roll No", value: "roll_no" },
    ],
    awspath: null, tenant: null, ay_list: [], ay: "", todays_order_list: [], canteen_menutype: "", installments: [],
  }),
  methods: {
    async handleKeyDown(event) {
      if (event.key === 'Enter') {
        this.fetchStudentData()
      }
    },
    fetchStudentData() {
      if (this.prn == '' || this.prn == null) {
        this.showSnackbar("red", "Please Enter PRN...");
        return
      }
      const data = {
        prn: this.prn,
        ay: this.ay
      };
      this.learner_details = [],
        this.overlay = true;
      axios
        .post("/Canteen/fetchStudentDataWWS", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.learner_details = res.data.learner_details,
              this.installments = res.data.installments
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    PlaceMealOrder() {
      const data = {
        prn: this.prn,
        ay: this.ay,
        canteen_menutype: this.canteen_menutype
      };
      this.overlay = true;
      this.canteen_menutype = "";
      this.installments = [];
      axios
        .post("/Canteen/PlaceMealOrderWWS", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Order Placed Successfully...");
            this.todays_order_list = res.data.todays_order_list
            this.learner_details = []
            this.prn = ""
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.$refs.focusMe.focus()
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onLoad() {
      axios
        .post("Canteen/placeMealOrderHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list),
              (this.ay = res.data.current_ay);
            this.todays_order_list = res.data.todays_order_list
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  created() {
    this.awspath = localStorage.getItem("awspath");
    this.tenant = localStorage.getItem("EPS-tenant");
  },
  mounted() {
    this.onLoad();
    this.$refs.focusMe.focus()
  },
  watch: {},
};
</script>
<style scoped>
.radio-container {
  margin-right: 35px;
}

.radiospace {
  padding: 0%;
}

sub-row {
  border: 2px solid #424093;
  margin: 1rem;
  border-radius: 5px;
}

i {
  font-size: 20px !important;
}

.i-table {
  width: 60%;
  margin: auto;
}
</style>